export const medicalGroupsFeatureKey = ['medical-groups'] as const;
